import { render, staticRenderFns } from "./SetupOnboarding.vue?vue&type=template&id=7b4c5d14"
import script from "./SetupOnboarding.vue?vue&type=script&lang=js"
export * from "./SetupOnboarding.vue?vue&type=script&lang=js"
import style0 from "./SetupOnboarding.vue?vue&type=style&index=0&id=7b4c5d14&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports